<template>
    <ValidationProvider v-slot="{ touched, errors, dirty, failedRules }" :name="name" :vid="inputId" :rules="rules">
        <slot></slot>

        <div v-if="touched && dirty && errors.length > 0" class="position-absolute mt-0 ml-5 invalid-feedback">
            <template v-if="typeof rules === 'string'">
                {{ errors[0] }}
            </template>
            <template v-else>
                <div v-for="(value, key, index) in failedRules" :key="`${ key }-${ index }`">
                    {{ rules[key] }}
                </div>
            </template>
        </div>
    </ValidationProvider>
</template>

<script>
    export default {
        props: {
            inputId: {
                required: true,
                type: String
            },
            name: {
                default: null,
                type: String
            },
            rules: {
                default: null,
                type: [String, Object]
            },
        }
    }
</script>
